import MicroModal from "micromodal";

export default function initCommonScripts() {
  loadingFin();
  resizeCheck();
  tabBtn();
  hashLinkSmoothScroll();
  setHeaderHeight();
  topBackBtn();
  openNav();
}

// ==================================
//ローディング完了判定
// ==================================
function loadingFin() {
  window.addEventListener("load", () => {
    document.body.classList.add("is-loaded");
  });
}

// ==================================
//リサイズ判定処理
// ==================================
function resizeCheck() {
  window.addEventListener("resize", function () {
    //リサイズでアニメーションとめる
    document.body.classList.add("is-resize");
    setTimeout(function () {
      document.body.classList.remove("is-resize");
    }, 500);
  });
}

// ==================================
//タブ切り替え処理
// ==================================
function tabBtn() {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const tabId = this.getAttribute("data-tab");

      tabButtons.forEach((btn) => btn.classList.remove("is-active"));
      tabContents.forEach((content) => content.classList.remove("is-active"));

      this.classList.add("is-active");
      document.getElementById(tabId).classList.add("is-active");
    });
  });
}

/**
 * ハッシュリンククリック時smooth、 headerガター調整
 */
export function hashLinkSmoothScroll() {
  const anchorLinks = document.querySelectorAll('a[href*="#"]');
  anchorLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      // URLからベースURLを削除して、純粋なハッシュを取得
      const currentUrl = window.location.href.split('#')[0]; // 現在のURLのベース部分
      const targetUrl = link.href.split('#')[0]; // リンクのURLのベース部分
  
      if (currentUrl === targetUrl) { // リンクが現在のページを指しているかチェック
        const hash = link.hash;
        const targetElm = document.querySelector(hash);
        if (targetElm) {
          e.preventDefault(); // デフォルトの動作をキャンセル
          _scrollToTarget(targetElm);
        }
      } // それ以外の場合、通常のリンクとして機能させる（何もしない）
    });
  });

  // アンカー付きでページ遷移した場合
  const urlHash = location.hash;
  if (urlHash) {
    const targetElm = document.querySelector(urlHash);

    window.addEventListener("load", () => {
      _scrollToTarget(targetElm);
    });
  }

  // 引数のターゲットをもとに画面スクロールする関数
  function _scrollToTarget(targetElm, smooth = true) {
    if (targetElm) {
      const targetRect = targetElm.getBoundingClientRect().top;
      let fixGutter = document.querySelector(".js-header-fixed").clientHeight;

      const targetPos = targetRect + window.scrollY - fixGutter - 30;

      window.scrollTo({
        top: targetPos,
        behavior: smooth ? "smooth" : "auto",
      });
    }
  }
}

/**
 * ヘッダーの高さをCSS変数に設定する関数
 * 要素のリサイズを検知して再取得します。
 */
function setHeaderHeight(cssVariableName = "--header-height") {
  const header = document.querySelector(".js-header");

  if (!header) return;

  // position: fixed されていたら値を更新するような処理にしたいので
  // この部分に処理追加予定。fixedがなくなれば値を0にする処理も必要かも。

  let headerH = header.clientHeight;
  document.documentElement.style.setProperty(cssVariableName, headerH + "px");

  // 要素のリサイズを監視して再取得
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      // ヘッダーの高さを再設定
      headerH = entry.contentRect.height;
      document.documentElement.style.setProperty(
        cssVariableName,
        headerH + "px"
      );
    }
  });
  resizeObserver.observe(header);
}

// ====================
//  TOPに戻るボタンスクロールで消す
// ====================
function topBackBtn() {
  const target = document.getElementById("js-go-top");
  if (!target) return;

  //スクロールで消す
  window.addEventListener("scroll", () => {
    if (window.scrollY > window.innerHeight) {
      if (!target.classList.contains("is-active")) {
        target.classList.add("is-active");
      }
    } else {
      if (target.classList.contains("is-active")) {
        target.classList.remove("is-active");
      }
    }

        // 特定位置で固定
        const fixTrigger = document.getElementById("js-observer-to-top");
        if (fixTrigger) {
          let triggerRect = fixTrigger.getBoundingClientRect();
          let triggerGutter = 0;
          console.log(triggerRect);
      
          if (window.innerHeight >= triggerRect.top + triggerGutter) {
            target.classList.add("is-fixed");
          } else {
            target.classList.remove("is-fixed");
          }
        }
  });

}



// ========================
// ハンバーガー開閉処理
// ========================
function openNav() {
  MicroModal.init();

  //mediaqueryでハンバーガー実装
  const mediaQuery = window.matchMedia("(max-width: 1080px)");
  const hamburger = document.getElementById("hamburger");
  const navigation = document.getElementById("navigation");
  const hlogo = document.querySelector(".l-header__logo-recruit");

  if (!hamburger || !navigation) {
    return;
  }

  switchMenu(mediaQuery);
  mediaQuery.addEventListener("change", switchMenu);

  function switchMenu(mq) {
    if (mq.matches) {
      navigation.ariaHidden = true;
  
      // ハンバーガークリック
      hamburger.addEventListener("click", () => {
        let hamburgerFlag = hamburger.getAttribute('aria-expanded') === "true";
        hamburger.setAttribute('aria-expanded', !hamburgerFlag);
  
        if (navigation.classList.contains("is-open")) {
          hamburger.classList.remove("is-open");
          if(hlogo){
            hlogo.classList.remove("is-open");
          }
          MicroModal.close("navigation");
        } else {
          hamburger.classList.add("is-open");
          if(hlogo){
          hlogo.classList.add("is-open");
          }
          MicroModal.show("navigation", {
            onClose: () => {
              hamburger.classList.remove("is-open");
            }
          });
        }
      });
    }
  }
  

  //リンククリックでモーダル閉じる処理
  const links = navigation.querySelectorAll(".modal-content__link");
  const linkschild = navigation.querySelectorAll(".modal-content-child__link");

  links.forEach((link) => {
    link.addEventListener("click", () => {
      if (navigation.classList.contains("is-open")) {
        hamburger.classList.remove("is-open");
        MicroModal.close("navigation");
      }
    });
  });

  linkschild.forEach((link) => {
    link.addEventListener("click", () => {
      if (navigation.classList.contains("is-open")) {
        hamburger.classList.remove("is-open");
        MicroModal.close("navigation");
        navigation.style.transition = "none";
      }
    });
  });
}